var _circle, _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgUspCareProducts = function SvgUspCareProducts(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 64 67",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 33,
    cy: 22,
    r: 22,
    fill: "#F4F3F0"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.3335 57H9.3335V61C9.3335 62.0609 9.75492 63.0783 10.5051 63.8284C11.2552 64.5786 12.2726 65 13.3335 65H25.3335C26.3944 65 27.4118 64.5786 28.1619 63.8284C28.9121 63.0783 29.3335 62.0609 29.3335 61V57Z",
    stroke: "#1D1D1B",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M29.3333 57H9.33328L2.04794 9.608C1.96031 9.03813 1.9969 8.45606 2.15522 7.90165C2.31353 7.34725 2.58983 6.83362 2.96518 6.39597C3.34053 5.95831 3.80606 5.60697 4.32987 5.36603C4.85367 5.12508 5.42338 5.00022 5.99994 5H32.6666C33.2432 5.00022 33.8129 5.12508 34.3367 5.36603C34.8605 5.60697 35.326 5.95831 35.7014 6.39597C36.0767 6.83362 36.353 7.34725 36.5113 7.90165C36.6697 8.45606 36.7063 9.03813 36.6186 9.608L29.3333 57Z",
    stroke: "#1D1D1B",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M3.18359 17H35.4929",
    stroke: "#1D1D1B",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M53.3335 61C53.3335 62.0609 53.7549 63.0783 54.5051 63.8284C55.2552 64.5786 56.2726 65 57.3335 65C58.3944 65 59.4118 64.5786 60.1619 63.8284C60.9121 63.0783 61.3335 62.0609 61.3335 61V9C61.3335 7.93913 60.9121 6.92172 60.1619 6.17157C59.4118 5.42143 58.3944 5 57.3335 5C56.2726 5 55.2552 5.42143 54.5051 6.17157C53.7549 6.92172 53.3335 7.93913 53.3335 9V61Z",
    stroke: "#1D1D1B",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M41.3389 57H53.3389",
    stroke: "#1D1D1B",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M41.3389 49H53.3389",
    stroke: "#1D1D1B",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M41.3389 41H53.3389",
    stroke: "#1D1D1B",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
export default SvgUspCareProducts;